import UserRequestDTO from "../../../../shared/dtos/userRequestDTO";
import { StatusTranslations } from "../../../../shared/constants/Status";

const normalizeText = (value: string): string =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");

const collectSearchValues = (value: unknown, parts: string[]): void => {
  if (value == null) {
    return;
  }

  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    const text = String(value).trim();
    if (text) {
      parts.push(text);
    }
    return;
  }

  if (value instanceof Date) {
    parts.push(value.toISOString());
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => collectSearchValues(item, parts));
    return;
  }

  if (typeof value === "object") {
    Object.values(value).forEach((item) => collectSearchValues(item, parts));
  }
};

const getUserRequestSearchText = (userRequest: UserRequestDTO): string => {
  const parts: string[] = [];

  collectSearchValues(userRequest, parts);

  const statusTranslation = StatusTranslations.find(
    (status: { name: string }) => status.name === userRequest.status,
  )?.translation;

  if (statusTranslation) {
    parts.push(statusTranslation);
  }

  if (userRequest.qrFee && parseFloat(userRequest.qrFee.toString()) > 0) {
    parts.push("partner");
  }

  return normalizeText(parts.join(" "));
};

export const userRequestMatchesSearch = (
  userRequest: UserRequestDTO,
  query: string,
): boolean => {
  const normalizedQuery = normalizeText(query.trim());
  if (!normalizedQuery) {
    return true;
  }

  const haystack = getUserRequestSearchText(userRequest);
  const terms = normalizedQuery.split(/\s+/).filter(Boolean);

  return terms.every((term) => haystack.includes(term));
};

export const filterUserRequestsBySearch = (
  userRequests: UserRequestDTO[],
  query: string,
): UserRequestDTO[] => {
  if (!query.trim()) {
    return userRequests;
  }

  return userRequests.filter((userRequest) =>
    userRequestMatchesSearch(userRequest, query),
  );
};
